import 
    constants, {
    FIND_ADS_CAMPAIGN_ERROR,
    PRERECORDED, LIVEREAD,
    WATCHLIST,
    CUSTOM_TIMESPAN_INVALID,
    ATTRIBUTE_ROLES
} from './constant';
import _ from "lodash";
import moment from 'moment';
import {
    INPUT_ERROR_MESSAGE,
    EMAIL_LIMIT,
    DEFAULT_EMAIL_INFO,
    EMPTY_MESSAGE_ERROR
} from '../components/AdvertiserEmailInfo';
import { get } from 'lodash';

function checkValidName(name) {
    let specialChars = '\\"'.split('')
    for (let item of specialChars) {
        if (_.includes(name, item)) {
            return false
        }
    }
    return true
}

export function checkValidEmailInfo(currentEmail, emails, allowEmpty = false) {
    if (currentEmail) {
        if (!isEmail(currentEmail)) {
            return `${currentEmail} is not a valid email address`;
        }

        if (isEmailInList(currentEmail, emails)) {
            return `${currentEmail} is already in the list`;
        }

        if (isEmailListOverLimit(emails)) {
            return `Only ${EMAIL_LIMIT} emails are allowed`;
        }
    }
    else {
        if (emails.length === 0 && !allowEmpty) {
            return INPUT_ERROR_MESSAGE
        }
        else {
            if (emails.length > EMAIL_LIMIT) {
                return `Only ${EMAIL_LIMIT} emails are allowed`;
            }
        }
    }

    return '';
}

export function isEmail(email) {
    const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
}

export function isEmailInList(email, emails) {
    return !!emails.find(emailInList => emailInList.toLowerCase() === email.toLowerCase());
}

function isEmailListOverLimit(emails) {
    return emails.length >= EMAIL_LIMIT;
}

export const checkAdvertiserError = (advertiser, advertisers) => {
    const { advertiser_id, folder_id, advertiser_name = "" } = advertiser;
    if (advertiser_id !== 'editing') {
        const currentAdvertiser = advertisers.filter(item => {
            return item.folder_id === folder_id && item.advertiser_id === advertiser_id
        })
        if (currentAdvertiser.length === 0) {
            for (let i = 0; i < advertisers.length; i++) {
                if (advertisers[i].advertiser_name === advertiser_name) {
                    return constants.NAME_ADVERTISER_DUPLICATED
                }
            }
        }
        else {
            const restAdvertiser = advertisers.filter(item => {
                return item.advertiser_id !== advertiser_id
            })
            if (restAdvertiser.length > 0) {
                for (let i = 0; i < restAdvertiser.length; i++) {
                    if (restAdvertiser[i].advertiser_name === advertiser_name) {
                        return constants.NAME_ADVERTISER_DUPLICATED
                    }
                }
            }
        }
    }
    if (!checkValidName(advertiser_name)) {
        return constants.NAME_ADVERTISER_INVALID
    }
    if (!advertiser_name.length) {
        return constants.NAME_ADVERTISER_REQUIRED
    }
    
    if (advertiser_name.length > 50) {
        return constants.NAME_ADVERTISER_LENGTH_REQUIRED
    }
    if (advertiser_id === "editing") {
        for (let i = 0; i < advertisers.length; i++) {
            if (advertisers[i].advertiser_name === advertiser_name) {
                return constants.NAME_ADVERTISER_DUPLICATED
            }
        }
    }
    return ""
}

export const checkMultiMarketError = (advertiser, advertiserInMultipleMarkets) => {
    const { isMultiMarket } = advertiser;

    if (advertiserInMultipleMarkets && _.isNil(isMultiMarket)) {
        return constants.ADVERTISER_MULTI_MARKET_REQUIRED;
    }

    return '';
}

export const checkCampaignError = (campaign, campaigns) => {
    const { campaign_id, id, campaign_name = "", advertiser_id, campaignCalendar } = campaign
    if (campaign_id !== 'editing') {
        const currentCampaign = campaigns.filter(item => {
            return item.campaign_id === campaign_id
        })
        if (currentCampaign.length === 0) {
            for (let i = 0; i < campaigns.length; i++) {
                if (campaigns[i].campaign_name === campaign_name) {
                    return constants.NAME_CAMPAIGN_DUPLICATED
                }
            }
        }
        else {
            const restCampaign = campaigns.filter(item => {
                return item.campaign_id !== campaign_id
            })
            if (restCampaign.length > 0) {
                for (let i = 0; i < restCampaign.length; i++) {
                    if (restCampaign[i].campaign_name === campaign_name) {
                        return constants.NAME_CAMPAIGN_DUPLICATED
                    }
                }
            }
        }
    }
    if (!checkValidName(campaign_name)) {
        return constants.NAME_CAMPAIGN_INVALID
    }
    if (!campaign_name.length) {
        return constants.NAME_CAMPAIGN_REQUIRED
    }
    if (!advertiser_id) {
        return constants.ADVERTISER_REQUIRED
    }
    if (campaign_name.length > 100) {
        return constants.NAME_CAMPAIGN_LENGTH_REQUIRED
    }
    if(!campaignCalendar.selected) {
        return constants.NAME_DATETIME_REQUIRED
    }
    if (campaign_id === "editing") {
        for (let i = 0; i < campaigns.length; i++) {
            if (campaigns[i].campaign_name === campaign_name && id !== campaigns[i].campaign_id) {
                return constants.NAME_CAMPAIGN_DUPLICATED
            }
        }
    }
    const ranges = _.get(campaign, 'custom_date_range.ranges', []);
    const isInvalidRanges = ranges.filter(range => !range.check);
    if (isInvalidRanges.length > 0) {
        return CUSTOM_TIMESPAN_INVALID;
    }
    return '';
}

export const validateFindAdsData = (campaign) => {
    const watchlistSelected = get(campaign, [WATCHLIST, 'watchlist_ids'], []).length > 0;
    const preRecordedSelected = get(campaign, [PRERECORDED, 'paramSearch']);
    const liveReadSelected = get(campaign, [LIVEREAD, 'paramSearch']);

    if(!(watchlistSelected || preRecordedSelected || liveReadSelected)){
        return FIND_ADS_CAMPAIGN_ERROR.ADS_SEARCH_REQUIRED;
    }
    return '';
}

export const validateStations = (campaign) => {
    const stationList = get(campaign, 'stationList', []);
    if(stationList.length === 0){
        return FIND_ADS_CAMPAIGN_ERROR.STATION_MARKET_REQUIRED;
    }
    return '';
}

export const validateEmailInfo = (emailInfo, isEmailInfoRequired, allowEmpty = false) => {
    if(!isEmailInfoRequired){
        return {
            ...emailInfo,
            emailError: '',
            msgError: ''
        }
    }
    if (!allowEmpty && !emailInfo) {
        return {
            ...DEFAULT_EMAIL_INFO,
            emailError: INPUT_ERROR_MESSAGE
        };
    }
    const { emailValue, emails = [] } = emailInfo;
    const errorMsg = checkValidEmailInfo(emailValue, emails, allowEmpty);

    // If email is invalid or message is blank return error message. Otherwise, check whether
    // we have a new email to be added or simply return the valid emailInfo.
    if (errorMsg) {
        return {
            ...emailInfo,
            emailError: errorMsg,
        };
    } else {
        if (emailValue) {
            return {
                ...emailInfo,
                emails: [...emails, emailValue],
                emailError: '',
                msgError: '',
                emailValue: ''
            };
        } else {
            return {
                ...emailInfo,
                emailError: '',
                msgError: '',
                emailValue: ''
            };
        }
    }
};

export const validateFolderName = (name, folders) => {
    if (name === '') {
        return constants.FOLDER_NAME_REQUIRED
    }
    if (name.length > 50) {
        return constants.FOLDER_NAME_LENGTH_REQUIRED
    }
    if (!checkValidName(name)) {
        return constants.FOLDER_NAME_INVALID
    }
    let isDuplicated = false
    for (let i = 0; i < folders.length; i++) {
        if (folders[i].folder_name.trim() === name.trim()) {
            isDuplicated = true
            break
        }
    }
    if (isDuplicated) {
        return constants.FOLDER_NAME_DUPLICATED
    }
    return ""
};

//Validate if date match "MM/DD/YYYY" or "M/D/YYYY"
export function validateDateFieldCalendar(date) {
    const date_regex = /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;
    return date_regex.test(date);
}

//Validate if start date is not greater than end date
export function validateDateRange(start, end, format) {
    const mStart = format ? moment(start, format) : moment(new Date(start));
    const mEnd = format ? moment(end, format) : moment(new Date(end));
    return (!mStart.isAfter(mEnd));
  }


export function checkMaximumDuration(start, end, maximum){
    const mStart = moment(new Date(start));
    const mEnd = moment(new Date(end));
    
    return (mEnd.diff(mStart, 'days') <= maximum);
}

/**
 * 
 * @param {Array<Object>} userRoles array of user roles object Ex: [{ id, name }]
 */
export function getAttributeRoles(userRoles = []) {
    return userRoles.filter(role => ATTRIBUTE_ROLES.includes(role.id));
};

export function normalizeMetric(value){
    if (_.isNil(value)){
        return 'N/A';
    }
    return parseFloat(value).toLocaleString();
}

export function validateIndustryCategorization(advertiser) {
    const { industry } = advertiser || {};
    if (_.isEmpty(industry)) {
        return {
            industry: 'Please select an Industry',
            category: 'Please select a Category',
        };
    };
    if (_.isEmpty(industry.category)) {
        return {
            category: 'Please select a Category',
        }
    }
}

export function validateConnectionType(advertiser) {
    const { trackingDataSourceName } = advertiser || {};
    if (!trackingDataSourceName) {
        return 'Attribute connection type is required'
    }
}